<template>
  <footer class="d-flex flex-column pt-3 mt-2" app>
    <div class="footer">
      <div
        class="text-center w-100 indigo--text text--darken-4 mb-1"
        style="font-size: small"
      >
        © {{ new Date().getFullYear() }}
        <a
          href="https://www.nexusgroup.com/"
          target="_blank"
          class="light-blue--text text--darken-4"
          >nexusgroup.com</a
        >. All rights reserved.
      </div>
      <!-- <div class="ml-14 mb-1 mt-1 pb-1 pt-1">
        <v-img width="6rem" src="../../assets/logo/footerLogo.png"></v-img>
      </div> -->
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.footer-logo {
  width: 100px;
}

.footer {
  margin-top: auto;
  bottom: 4px;
  position: absolute;
  align-self: center;
}
</style>
